/**
 * 车辆汇总统计信息
 */
import React from 'react';

import PageLayout from '../../ui/PageLayout';

const columns = [{
    title: '',
    dataIndex: 'dataType',
    width: '15%',
}, {
    title: '入驻商户数量',
    dataIndex: 'members',
    width: '15%',
}, {
    title: '商户用户数',
    dataIndex: 'memberUsers',
    width: '15%',
}, {
    title: '商城授权登录用户',
    dataIndex: 'mallAuthUsers',
    width: '15%',
}, {
    title: '上架车辆总数',
    dataIndex: 'onSellingVehicles',
    width: '15%',
}, {
    title: '下架车辆总数',
    dataIndex: 'putOffVehicles',
    width: '15%',
}, {
    title: '当前展示车辆数',
    dataIndex: 'onSelling',
    width: '15%',
}];

class MallStatisticsIndex extends React.Component {

    state = {
        loadData: ''
    };

    render() {
        return (
            <PageLayout
                page={false}
                rowKey="id"
                url="/mallStatistic/data"
                requestType="get"
                columns={columns}
                loadData={(func) => { this.setState({ loadData: func }) }}
            />
        )
    }
}

export default MallStatisticsIndex;